export default __webpack_public_path__ + "static/media/2214.fc6e21b0.png";